import type { FunctionComponent, PropsWithChildren } from 'react';
import React from 'react';

import styles from './Board.less';

export const List: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => <div className={styles.list}>{children}</div>;
